import { useParams } from "react-router-dom"
import PasswordResetLinkSent from "../PasswordResetLinkSent"
import getPool from '../../UserPool';
import { DEFAULT_CLIENT_ID, DEFAULT_USER_POOL_ID } from '../../shared/Config';
import { useState } from "react";
import { RecoveryPasswordService } from "../../services/RecoveryPasswordService";
import { Form } from "react-bootstrap";
import style from '../../components/Form.module.scss';
import Warnings from '../../components/Warning';

const SEND_EMAIL_ERROR =
    'Não foi possível enviar o link de recuperação. Tente novamente.';

function RecoveryEmailPassword({ email, recoveryEmail }: { email: any, recoveryEmail: any }) {
    const [stage, setStage] = useState(1); // 1 = set email options stage, 2 = set code stage // 3 = set recovery code stage
    const [valueChecked, setValueChecked] = useState('')
    const [isSending, setIsSending] = useState(false)
    const [submitError, setSubmitError] = useState(false)

    const handleValueChange = (event: any) => {
        setValueChecked(event.target.value)
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const params = Object.fromEntries(urlParams.entries());
    let Pool: any = null
    const routeParams = useParams()

    if (params.client_id) {
        Pool = getPool(routeParams.pool_id || "", params.client_id)
    } else {
        Pool = getPool(DEFAULT_USER_POOL_ID, DEFAULT_CLIENT_ID) // default redirect without params
    }

    const postRecovery = (valueChecked: string) => {
        return RecoveryPasswordService.sendCodeRecoveryEmail({ email: email, poolId: Pool.getUserPoolId() }, valueChecked)
    }

    const sendEmailCode = async (event: { preventDefault: () => void; }) => {
        event.preventDefault();

        if (!valueChecked || isSending) return;

        setSubmitError(false);
        setIsSending(true);

        try {
            await postRecovery(valueChecked);
            setStage(2);
        } catch {
            setSubmitError(true);
        } finally {
            setIsSending(false);
        }
    }

    return (
        <>
            {stage === 1 && (
                <>
                    <div style={{ padding: '1.5em 3em 0em' }}>
                        <p style={{ textAlign: 'center', lineHeight: '30px' }}>
                            Selecione um e-mail para
                            encaminhar o link de recuperação.
                        </p>
                    </div>
                    <Form onSubmit={sendEmailCode}
                        method="post"
                        className='col-12'
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'center'
                        }}
                    >
                        {submitError && (
                            <Warnings warning={SEND_EMAIL_ERROR} type="error" />
                        )}
                        <Form.Group>
                            <Form.Check
                                type='radio'
                                className="mb-3"
                                id='radioCheck'
                                label={`Enviar para ${email}`}
                                value='email'
                                checked={valueChecked === 'email'}
                                onChange={handleValueChange}
                                disabled={isSending}
                            />
                            <Form.Check
                                type='radio'
                                className="mb-3"
                                id='radio-recoveryemail'
                                label={`Enviar para ${recoveryEmail}`}
                                value='recoveryEmail'
                                checked={valueChecked === 'recoveryEmail'}
                                onChange={handleValueChange}
                                disabled={isSending}
                            />
                        </Form.Group>
                        <div className='d-flex justify-content-center mb-4 px-5'>
                            <button name='btnSubmit'
                                className={style.submitButton}
                                id="submitButton"
                                type="submit"
                                disabled={isSending}>
                                {isSending ? 'Enviando…' : 'Enviar'}
                            </button>
                        </div>
                    </Form>
                </>
            )}
            {stage === 2 && (
                <>
                    <PasswordResetLinkSent email={email} responseType={valueChecked as 'email' | 'recoveryEmail'} />
                </>
            )}
        </>
    )
}

export default RecoveryEmailPassword